export const DEFAULT_GRADE_POINT_LABELS = {
    SGPA: 'SGPA',
    CGPA: 'CGPA',
};

export const normalizeGradePointLabels = (labels = {}) => ({
    SGPA: labels && labels.SGPA ? labels.SGPA : DEFAULT_GRADE_POINT_LABELS.SGPA,
    CGPA: labels && labels.CGPA ? labels.CGPA : DEFAULT_GRADE_POINT_LABELS.CGPA,
});
